// extracted by mini-css-extract-plugin
export default {"container":"panelMetrics-container__dC2V8","metricTitle":"panelMetrics-metricTitle__pNIQC","tag":"panelMetrics-tag__CK2lG","metric":"panelMetrics-metric__J9Exj"};